import worktypes from '../../worktypes'

export default {
  obraID: {
    value: null
  },
  identificacao: {
    value: null,
    maxlength: 3,
    required: true,
    state: null
  },
  selecionado: {
    value: null,
    required: false,
    state: null,
    defaultValue: false
  },
  detentora: {
    value: null,
    maxlength: 20,
    required: false,
    state: null
  },
  idDetentora: {
    value: null,
    maxlength: 20,
    required: false,
    state: null
  },
  latitude: {
    value: null,
    required: false,
    state: null
  },
  longitude: {
    value: null,
    required: false,
    state: null
  },
  altitude: {
    value: null,
    required: false,
    state: null
  },
  cep: {
    value: null,
    required: false,
    state: null
  },
  endereco: {
    value: null,
    maxlength: 50,
    required: false,
    state: null
  },
  numero: {
    value: null,
    maxlength: 10,
    required: false,
    state: null
  },
  complemento: {
    value: null,
    maxlength: 20,
    required: false,
    state: null
  },
  bairro: {
    value: null,
    maxlength: 50,
    required: false,
    state: null
  },
  cidade: {
    value: null,
    required: false,
    options: [],
    state: null
  },
  estado: {
    value: null,
    required: false,
    options: [],
    state: null
  },
  tipo: {
    value: null,
    maxlength: 10,
    options: worktypes.types,
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/components/construction/candidate-form.js